import { createSelector } from '@reduxjs/toolkit';
import {
  employeesShortNamesAndI,
  functionsNotDeleted,
  getContactsAsUsers,
  type NameEntry,
  type PartnerContactAsUser,
  tasksNotDeleted,
} from 'src/store/selectors';
import type { ListSectionItemInput } from 'src/library/lists/listSectionItemInput';
import { eventAssigneesText } from 'src/store/eventAssigneesText';
import type { FunctionViewModel, TaskViewModel } from '@trinnvis/dabih-api-client';

export function taskToListItem(
  task: TaskViewModel,
  functions: FunctionViewModel[],
  shortNamesAndI: NameEntry[],
  contactsAsUsers: PartnerContactAsUser[],
): ListSectionItemInput {
  return {
    accessible: true,
    label: task.name,
    rightLabel: eventAssigneesText(task, functions, shortNamesAndI, contactsAsUsers),
    rightLabelClass: 'assignee',
    clickData: task.uuid,
    href: '/tasks/' + task.uuid,
  };
}

export const tasksAsListItems = createSelector(
  tasksNotDeleted,
  functionsNotDeleted,
  employeesShortNamesAndI,
  getContactsAsUsers,
  function (
    tasks: TaskViewModel[],
    functions: FunctionViewModel[],
    shortNamesAndI: NameEntry[],
    contactsAsUsers: PartnerContactAsUser[],
  ): ListSectionItemInput[] {
    return tasks.map((item) => {
      return taskToListItem(item, functions, shortNamesAndI, contactsAsUsers);
    });
  },
);
